import moment from 'moment';
import { DATE_FORMATS } from '../../constants/appConstants';

export const formatDate = (date, format = DATE_FORMATS.DISPLAY) => {
  return moment(date).format(format);
};

export const parseDate = (dateString, format = DATE_FORMATS.API) => {
  return moment(dateString, format);
};

export const isDateValid = date => {
  return moment(date).isValid();
};

export const formatTime = (time) => {
  if (!time) return '';
  // Support various common time formats including dots and colons
  const m = moment(time, ['h.mm a', 'h:mm a', 'HH:mm', 'H.mm', 'h.mm', 'h:mm', 'hh:mm A']);
  return m.isValid() ? m.format('hh:mm A') : time;
};

export const getDateRange = (startDate, endDate) => {
  // Logic for date range
};
